import { API } from "../helpers/API/amplifyApi";
export const lazyFetch = async (tableName = "", listOfKeys = []) => {
  return await API.get("lazyFetching", "/lazyFetching", {
    queryStringParameters: { tableName, listOfKeys },
  });
};
